module.exports = __webpack_public_path__ + "static/media/marijuana active.1415fc55.svg";